import { render, staticRenderFns } from "./content-modules.vue?vue&type=template&id=af41a042"
import script from "./content-modules.vue?vue&type=script&lang=js"
export * from "./content-modules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports